import React, { Fragment } from 'react'
import { WaitMessage } from '@wf-wfria/pioneer-core'

export function CustomWaitMessage({ isLoading }) {
	if (isLoading) {
		return (
			<WaitMessage
				render={() => <span className={'CustomWaitMessage'}>Loading...</span>}
			/>
		)
	}
	return <Fragment />
}
